export enum FeedbackReviewStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
  SAVED = 'SAVED',
}
